import { render, staticRenderFns } from "./economicManage.vue?vue&type=template&id=a49abfa4&scoped=true"
import script from "./economicManage.vue?vue&type=script&lang=js"
export * from "./economicManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49abfa4",
  null
  
)

export default component.exports